import React from "react";

const TermsAndConditions = () => {
  // If you're using react-router-dom for navigation, you could use useNavigate().
  // For simplicity, let's just use the browser's history to go back.
  const goBack = () => {
    window.history.back();
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h1>Terms & Conditions</h1>

      {/* ---- ENGLISH ---- */}
      <section>
        <h2>English</h2>
        <ol>
          <li>
            <strong>Reservation and Payment</strong>
            <ul>
              <li>
                Reservations are made through the application by selecting
                available dates and completing payment by credit card.
              </li>
              <li>
                All fees and charges must be paid in full at the time of booking.
              </li>
            </ul>
          </li>
          <li>
            <strong>Cancellation and Refund Policy</strong>
            <ul>
              <li>
                <em>Full Refund (30 Days or More):</em> If a reservation is
                canceled 30 days or more prior to the arrival date, the user will
                receive a full refund of the reservation amount.
              </li>
              <li>
                <em>75% Refund (16–29 Days):</em> If a reservation is canceled
                between 16 and 29 days before the arrival date, the user will
                receive 75% of the reservation amount.
              </li>
              <li>
                <em>50% Refund (15 Days or Less):</em> If a reservation is
                canceled 15 days or less prior to the arrival date, the user will
                receive 50% of the reservation amount.
              </li>
              <li>
                <em>Medical Exceptions:</em> If a user cannot proceed with their
                reservation due to documented medical reasons, a full refund will
                be granted regardless of the cancellation date.
              </li>
            </ul>
          </li>
          <li>
            <strong>Guest Responsibilities</strong>
            <ul>
              <li>
                Guests are expected to treat the property with care and are
                responsible for any damage to the premises or its contents during
                their stay.
              </li>
              <li>
                In the event of damage, guests agree to cover repair or
                replacement costs as determined by the property owner or manager.
              </li>
              <li>
                <strong>No parties or events</strong> are allowed on the
                property.
              </li>
              <li>
                The <strong>maximum number of guests is 6</strong>, unless
                otherwise agreed in writing.
              </li>
              <li>
                <strong>Smoking is not allowed</strong> on the property.
              </li>
            </ul>
          </li>
          <li>
            <strong>Contact for Incidents</strong>
            <p>
              If you experience any issues during your stay (e.g., maintenance
              problems, unforeseen circumstances), please contact:
              <br />
              <strong>Phone:</strong> +34 696489166 (Marta or Danilo)
            </p>
          </li>
          <li>
            <strong>Limitation of Liability</strong>
            <ul>
              <li>
                The property owner/manager shall not be held liable for
                accidents, injuries, or losses incurred on the premises, except
                in cases of proven negligence.
              </li>
              <li>
                Guests are advised to secure appropriate travel and medical
                insurance for the duration of their stay.
              </li>
            </ul>
          </li>
          <li>
            <strong>Acceptance of Terms</strong>
            <p>
              By making a reservation through this application, users agree to
              comply with and be bound by these Terms & Conditions. Any
              violations may result in cancellation of the reservation without
              refund, and/or additional charges in accordance with these
              policies.
            </p>
          </li>
        </ol>
      </section>

      <hr />

      {/* ---- SPANISH ---- */}
      <section>
        <h2>Español</h2>
        <ol>
          <li>
            <strong>Reservas y Pago</strong>
            <ul>
              <li>
                Las reservas se realizan a través de la aplicación, seleccionando
                las fechas disponibles y completando el pago con tarjeta de
                crédito.
              </li>
              <li>
                Todas las tarifas y cargos deben ser pagados en su totalidad al
                momento de la reserva.
              </li>
            </ul>
          </li>
          <li>
            <strong>Política de Cancelación y Reembolso</strong>
            <ul>
              <li>
                <em>Reembolso Completo (30 Días o Más):</em> Si una reserva se
                cancela 30 días o más antes de la fecha de llegada, el usuario
                recibirá un reembolso completo del importe de la reserva.
              </li>
              <li>
                <em>Reembolso del 75% (16–29 Días):</em> Si una reserva se
                cancela entre 16 y 29 días antes de la fecha de llegada, el
                usuario recibirá el 75% del importe de la reserva.
              </li>
              <li>
                <em>Reembolso del 50% (15 Días o Menos):</em> Si una reserva se
                cancela 15 días o menos antes de la fecha de llegada, el usuario
                recibirá el 50% del importe de la reserva.
              </li>
              <li>
                <em>Excepciones Médicas:</em> Si un usuario no puede proceder con
                su reserva por razones médicas documentadas, se otorgará un
                reembolso completo sin importar la fecha de cancelación.
              </li>
            </ul>
          </li>
          <li>
            <strong>Responsabilidades de los Huéspedes</strong>
            <ul>
              <li>
                Se espera que los huéspedes traten la propiedad con cuidado y son
                responsables de cualquier daño a las instalaciones o su contenido
                que ocurra durante su estancia.
              </li>
              <li>
                En caso de daños, los huéspedes aceptan cubrir los costos de
                reparación o reemplazo según lo determine el propietario o
                administrador de la propiedad.
              </li>
              <li>
                <strong>No se permiten fiestas o eventos</strong> en la
                propiedad.
              </li>
              <li>
                <strong>El número máximo de huéspedes es de 6 personas</strong>,
                a menos que se acuerde lo contrario por escrito.
              </li>
              <li>
                <strong>Está prohibido fumar</strong> en la propiedad.
              </li>
            </ul>
          </li>
          <li>
            <strong>Contacto para Incidencias</strong>
            <p>
              Si experimenta algún problema durante su estancia (p. ej., problemas
              de mantenimiento, circunstancias imprevistas), por favor contacte a:
              <br />
              <strong>Teléfono:</strong> +34 696489166 (Marta o Danilo)
            </p>
          </li>
          <li>
            <strong>Limitación de Responsabilidad</strong>
            <ul>
              <li>
                El propietario/administrador de la propiedad no será responsable
                de accidentes, lesiones o pérdidas sufridas en las instalaciones,
                excepto en casos de negligencia demostrada.
              </li>
              <li>
                Se recomienda a los usuarios contar con un seguro de viaje y
                médico adecuado durante su estancia.
              </li>
            </ul>
          </li>
          <li>
            <strong>Aceptación de los Términos</strong>
            <p>
              Al realizar una reserva a través de esta aplicación, los usuarios
              aceptan cumplir y estar sujetos a estos Términos y Condiciones.
              Cualquier infracción puede resultar en la cancelación de la reserva
              sin reembolso y/o cargos adicionales de acuerdo con estas
              políticas.
            </p>
          </li>
        </ol>
      </section>

      <hr />

      {/* ---- CATALAN ---- */}
      <section>
        <h2>Català</h2>
        <ol>
          <li>
            <strong>Reserva i Pagament</strong>
            <ul>
              <li>
                Les reserves es fan a través de l’aplicació, seleccionant les
                dates disponibles i completant el pagament amb targeta de crèdit.
              </li>
              <li>
                Totes les tarifes i càrrecs s’han de pagar íntegrament en el
                moment de la reserva.
              </li>
            </ul>
          </li>
          <li>
            <strong>Política de Cancel·lació i Reemborsament</strong>
            <ul>
              <li>
                <em>Reemborsament Complet (30 Dies o Més):</em> Si una reserva
                es cancel·la 30 dies o més abans de la data d’arribada, l’usuari
                rebrà un reemborsament complet de l’import de la reserva.
              </li>
              <li>
                <em>Reemborsament del 75% (16–29 Dies):</em> Si una reserva es
                cancel·la entre 16 i 29 dies abans de la data d’arribada,
                l’usuari rebrà el 75% de l’import de la reserva.
              </li>
              <li>
                <em>Reemborsament del 50% (15 Dies o Menys):</em> Si una reserva
                es cancel·la 15 dies o menys abans de la data d’arribada,
                l’usuari rebrà el 50% de l’import de la reserva.
              </li>
              <li>
                <em>Excepcions Mèdiques:</em> Si un usuari no pot realitzar la
                seva reserva per motius mèdics documentats, se li concedirà un
                reemborsament complet, independentment de la data de cancel·lació.
              </li>
            </ul>
          </li>
          <li>
            <strong>Responsabilitats dels Hostes</strong>
            <ul>
              <li>
                S’espera que els hostes tractin la propietat amb cura i són
                responsables de qualsevol dany que pugui produir-se a
                l’allotjament o al seu contingut durant la seva estada.
              </li>
              <li>
                En cas de danys, els hostes accepten cobrir els costos de
                reparació o substitució segons determini el propietari o gestor
                de la propietat.
              </li>
              <li>
                <strong>No es permeten festes o esdeveniments</strong> a la
                propietat.
              </li>
              <li>
                <strong>El nombre màxim de convidats és de 6 persones</strong>,
                llevat que s’acordi el contrari per escrit.
              </li>
              <li>
                <strong>No es permet fumar</strong> a la propietat.
              </li>
            </ul>
          </li>
          <li>
            <strong>Contacte per Incidències</strong>
            <p>
              Si teniu cap problema durant la vostra estada (p. ex., problemes de
              manteniment, circumstàncies imprevistes), si us plau contacteu amb:
              <br />
              <strong>Telèfon:</strong> +34 696489166 (Marta o Danilo)
            </p>
          </li>
          <li>
            <strong>Limitació de Responsabilitat</strong>
            <ul>
              <li>
                El propietari/gestor de la propietat no es farà responsable
                d’accidents, lesions o pèrdues sofertes a l’allotjament, excepte
                en casos de negligència demostrada.
              </li>
              <li>
                Es recomana als usuaris disposar d’una assegurança de viatge i
                mèdica adequada durant la seva estada.
              </li>
            </ul>
          </li>
          <li>
            <strong>Acceptació dels Termes</strong>
            <p>
              En fer una reserva a través d’aquesta aplicació, els usuaris
              accepten complir i estar subjectes a aquests Termes i Condicions.
              Qualsevol infracció pot resultar en la cancel·lació de la reserva
              sense reemborsament i/o càrrecs addicionals d’acord amb aquestes
              polítiques.
            </p>
          </li>
        </ol>
      </section>

      <hr />

      {/* ---- POLISH ---- */}
      <section>
        <h2>Polski</h2>
        <ol>
          <li>
            <strong>Rezerwacja i Płatność</strong>
            <ul>
              <li>
                Rezerwacji dokonuje się za pośrednictwem aplikacji, wybierając
                dostępne terminy i płacąc kartą kredytową.
              </li>
              <li>
                Wszystkie opłaty muszą zostać uregulowane w całości w momencie
                rezerwacji.
              </li>
            </ul>
          </li>
          <li>
            <strong>Zasady Anulowania i Zwrotu</strong>
            <ul>
              <li>
                <em>Pełny Zwrot (30 dni lub więcej):</em> Jeśli rezerwacja
                zostanie anulowana co najmniej 30 dni przed terminem
                zameldowania, użytkownik otrzyma pełny zwrot kosztów rezerwacji.
              </li>
              <li>
                <em>Zwrot 75% (16–29 dni):</em> Jeśli rezerwacja zostanie
                anulowana między 16 a 29 dniem przed terminem zameldowania,
                użytkownik otrzyma 75% kwoty rezerwacji.
              </li>
              <li>
                <em>Zwrot 50% (15 dni lub mniej):</em> Jeśli rezerwacja zostanie
                anulowana na 15 dni lub mniej przed terminem zameldowania,
                użytkownik otrzyma 50% kwoty rezerwacji.
              </li>
              <li>
                <em>Wyjątki Medyczne:</em> Jeśli użytkownik nie może zrealizować
                rezerwacji z powodów medycznych (udokumentowanych stosowną
                dokumentacją), przysługuje mu pełny zwrot kosztów, niezależnie od
                daty anulowania.
              </li>
            </ul>
          </li>
          <li>
            <strong>Obowiązki Gości</strong>
            <ul>
              <li>
                Od gości oczekuje się dbałości o obiekt. Ponoszą oni
                odpowiedzialność za wszelkie szkody w mieniu lub wyposażeniu,
                powstałe w trakcie pobytu.
              </li>
              <li>
                W przypadku uszkodzeń goście zobowiązują się do pokrycia kosztów
                naprawy lub wymiany, zgodnie z ustaleniami właściciela lub
                zarządcy obiektu.
              </li>
              <li>
                <strong>Imprezy i przyjęcia są zabronione</strong> w obiekcie.
              </li>
              <li>
                <strong>Maksymalna liczba osób wynosi 6</strong>, chyba że
                uzgodniono inaczej na piśmie.
              </li>
              <li>
                <strong>Obowiązuje zakaz palenia</strong> na terenie obiektu.
              </li>
            </ul>
          </li>
          <li>
            <strong>Kontakt w Sprawie Incydentów</strong>
            <p>
              W razie jakichkolwiek problemów w trakcie pobytu (np. problemy
              techniczne czy nieprzewidziane okoliczności), prosimy o kontakt:
              <br />
              <strong>Telefon:</strong> +34 696489166 (Marta lub Danilo)
            </p>
          </li>
          <li>
            <strong>Ograniczenie Odpowiedzialności</strong>
            <ul>
              <li>
                Właściciel/zarządca obiektu nie ponosi odpowiedzialności za
                wypadki, urazy czy straty poniesione na terenie obiektu, poza
                przypadkami udowodnionego zaniedbania.
              </li>
              <li>
                Zaleca się wykupienie odpowiedniego ubezpieczenia podróżnego i
                zdrowotnego na czas pobytu.
              </li>
            </ul>
          </li>
          <li>
            <strong>Akceptacja Warunków</strong>
            <p>
              Dokonując rezerwacji za pomocą tej aplikacji, użytkownik
              zobowiązuje się do przestrzegania niniejszych Warunków i Zasad.
              Jakiekolwiek naruszenie może skutkować anulowaniem rezerwacji bez
              zwrotu kosztów i/lub dodatkowymi opłatami zgodnie z tymi
              postanowieniami.
            </p>
          </li>
        </ol>
      </section>

      <hr />

      {/* ---- BACK ARROW BUTTON ---- */}
      <button
        onClick={goBack}
        style={{
          cursor: "pointer",
          padding: "0.5rem 1rem",
          marginTop: "1rem",
          borderRadius: "4px"
        }}
      >
        ← Back
      </button>
    </div>
  );
};

export default TermsAndConditions;
